import { render, staticRenderFns } from "./HeaderOa.vue?vue&type=template&id=0592d94e&scoped=true"
import script from "./HeaderOa.vue?vue&type=script&lang=js"
export * from "./HeaderOa.vue?vue&type=script&lang=js"
import style0 from "./HeaderOa.vue?vue&type=style&index=0&id=0592d94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0592d94e",
  null
  
)

export default component.exports